import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { UserProfile, EmployerProfile } from '../common/types';

interface StoreState {
  userProfile: UserProfile;
  setUserProfile: (profile: UserProfile) => void;
  employerProfile: EmployerProfile;
  setEmployerProfile: (profile: EmployerProfile) => void;
  touAccepted: boolean;
  setTouAccepted: (accepted: boolean) => void;
}

const useStore = create<StoreState>()(
  persist(
    (set) => ({
      userProfile: {
        employee_id: '',
        email: '',
        is_admin: false,
        verified: false,
        employer: '',
        created_at: '',
        updated_at: '',
        first_name: '',
        last_name: '',
        read_only: false,
      },
      setUserProfile: (profile: UserProfile) => set({ userProfile: profile }),
      employerProfile: {
        tax_id: '',
        funder_name: '',
        funder_id: '',
      },
      setEmployerProfile: (profile: EmployerProfile) =>
        set({ employerProfile: profile }),
      touAccepted: false,
      setTouAccepted: (accepted: boolean) => set({ touAccepted: accepted }),
    }),
    { name: 'userProfile-storage' },
  ),
);

export default useStore;
